/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rpe_Min_LabelInputs */

const fr_rpe_min_label = /** @type {(inputs: Rpe_Min_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPE Min`)
};

/**

* @param {Rpe_Min_LabelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const rpe_min_label = /** @type {((inputs?: Rpe_Min_LabelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rpe_Min_LabelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_rpe_min_label(inputs)
});